import axios from 'axios';

const log = require("loglevel").getLogger("CampaignService");
log.setLevel("error");

export const loadDropdownValues = key => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/campaign/dropdown/values`, {key})
		.then(async response => {
			const res = response.data.dropdown;
			log.debug("CampaignService -> loadDropdownValues -> return");
			return res;
		})
		.catch(response => {
			log.debug("CampaignService -> loadDropdownValues -> error: ");
			log.debug(response);
			return null;
		});
}

export const loadCampaignById = (id, loadStats) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/campaign/get/id`, { id, loadStats })
		.then(async response => {
			const res = response.data.data;
			log.debug("CampaignService -> loadCampaignById -> return");
			return res;
		})
		.catch(response => {
			log.debug("CampaignService -> loadCampaignById -> error: ");
			log.debug(response);
			return null;
		});
};

export const loadCampaignMembers = (campaignId) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/campaign/members`, {campaignId})
		.then(async response => {
			const res = response.data.data;
			log.debug("CampaignService -> loadCampaignMembers -> return");
			return res;
		})
		.catch(response => {
			log.debug("CampaignService -> loadCampaignMembers -> error: ");
			log.debug(response);
			return null;
		});
};

export const removeCampaignContact = (campaignId, contactId, contactEmail) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/campaign/contact/remove`, { campaignId, contactId, contactEmail })
		.then(async response => {
			const res = response.data;
			log.debug("CampaignService -> removeCampaignContact -> return");
			return res;
		})
		.catch(response => {
			log.debug("CampaignService -> removeCampaignContact -> error: ");
			log.debug(response);
			return null;
		});
};
export const addCampaignContact = (campaignId, contacts) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/campaign/contact/add`, {  campaignId,  contacts })
		.then(async response => {
			const res = response.data;
			log.debug("CampaignService -> removeCampaignContact -> return");
			return res;
		})
		.catch(response => {
			log.debug("CampaignService -> removeCampaignContact -> error: ");
			log.debug(response);
			return null;
		});
};

export const saveCampaign = (campaign) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/campaign`, {campaign})
		.then(async response => {
			const res = response.data;
			log.debug("CampaignService -> saveCampaign -> return");
			return res;
		})
		.catch(response => {
			log.debug("CampaignService -> saveCampaign -> error: ");
			log.debug(response);
			return null;
		});
};

export const getReplyCampaigns = () => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/campaign/replyio/campaign/validate`, {campaignId: '1164557'})
		.then(async response => {
			const res = response.data;
			log.debug("CampaignService -> getReplyCampaigns -> done");
			return res;
		})
		.catch(response => {
			log.debug("CampaignService -> getReplyCampaigns -> error: ");
			log.debug(response);
			return null;
		});
};

export const resumeCampaign = (campaignId, replyCampaignId,isManual) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/campaign/resume`, {campaignId, replyCampaignId,isManual})
		.then(async response => {
			const res = response.data;
			log.debug("CampaignService -> resumeCampaign -> return");
			return res;
		})
		.catch(response => {
			log.debug("CampaignService -> resumeCampaign -> error: ");
			log.debug(response);
			return null;
		});
};

export const pauseCampaign = (campaignId, replyCampaignId,isManual) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/campaign/pause`, {campaignId, replyCampaignId,isManual})
		.then(async response => {
			const res = response.data;
			log.debug("CampaignService -> pauseCampaign -> return");
			return res;
		})
		.catch(response => {
			log.debug("CampaignService -> pauseCampaign -> error: ");
			log.debug(response);
			return null;
		});
};

export const activateCampaign = (campaignId, vendor, replyCampaignId,isManual) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/campaign/activate`, {campaignId, vendor, replyCampaignId,isManual})
		.then(async response => {
			const res = response.data;
			log.debug("CampaignService -> activateCampaign -> return");
			return res;
		})
		.catch(response => {
			log.debug("CampaignService -> activateCampaign -> error: ");
			log.debug(response);
			return null;
		});
};

export const deleteCampaign = (campaignId) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/campaign/delete`, {campaignId})
		.then(async response => {
			const res = response.data;
			log.debug("CampaignService -> deleteCampaign -> return");
			return res;
		})
		.catch(response => {
			log.debug("CampaignService -> deleteCampaign -> error: ");
			log.debug(response);
			return null;
		});
};

export const loadCampaigns = (selectedFilters, forceReload) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/campaign/get`, {selectedFilters})
		.then(async response => {
			const res = response.data.data;
			log.debug("CampaignService -> loadCampaigns -> return");
			return res;
		})
		.catch(response => {
			log.debug("CampaignService -> loadCampaigns -> error: ");
			log.debug(response);
			return null;
		});
};
// add get member dict statuss members/status
export const loadCampaignMembersStatus = () => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/campaign/members/status`)
		.then(async response => {
			const res = response.data.data;
			log.debug("CampaignService -> loadCampaignMembersStatus -> return");
			return res;
		})
		.catch(response => {
			log.debug("CampaignService -> loadCampaignMembersStatus -> error: ");
			log.debug(response);
			return null;
		});
};
// add update member status members/update
export const updateCampaignMemberStatus = (campaignId, contactId, status) => {
	return axios.post(`${process.env.REACT_APP_HOST_URL}/campaign/members/update`, {campaignId, contactId, status})
		.then(async response => {
			const res = response.data;
			log.debug("CampaignService -> updateCampaignMemberStatus -> return");
			return res;
		})
		.catch(response => {
			log.debug("CampaignService -> updateCampaignMemberStatus -> error: ");
			log.debug(response);
			return null;
		});
};

export const addRelativeAccountsToContact = (campaignId, contactId, relatedAccounts) => {
	console.log("addRelativeAccountsToContact", campaignId, contactId, relatedAccounts);
	
	return axios.post(`${process.env.REACT_APP_HOST_URL}/campaign/contact/add-related-accounts`, {campaignId, contactId, relatedAccounts})
		.then(async response => {
			const res = response.data;
			log.debug("CampaignService -> addRelativeAccountsToContact -> return");
			return res;
		})
		.catch(response => {
			log.debug("CampaignService -> addRelativeAccountsToContact -> error: ");
			log.debug(response);
			return null;
		});
};